import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemSocialTwitter = function IconSystemSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.093 10.316 22.283 1h-1.94L13.23 9.089 7.55 1H1l8.589 12.231L1 23h1.94l7.51-8.542 6 8.542H23zm-2.658 3.023-.87-1.218L3.64 2.43h2.981l5.588 7.82.87 1.219 7.264 10.166h-2.98z"
  }));
};